import React from 'react';
import LeftCategorySidebar from '../features/common/LeftCategorySidebar';

function MainLayout({ children, showSidebar = true }) {
  return (
    <div className="min-h-screen">
      {/* Left Category Sidebar - Always visible for all users */}
      {showSidebar && <LeftCategorySidebar />}
      
      {/* Main Content - Offset for sidebar on desktop */}
      <div className={`${showSidebar ? 'lg:pl-16' : ''}`}>
        {children}
      </div>
    </div>
  );
}

export default MainLayout;
